import HARDCODE from '../../business-const/HardCode/HardCode'



const tipoPeriodicidadeList = (listaCompleta, incluirOpcaoSinglePremium, incluiMultiplosAnuais) => {
    
    const tipoPeriodicidadeListAux = [
        {
            id: HARDCODE.idTipoPeriodicidadeMensal, // HARDCODEBACKEND.idTipoPeriodicidadeMensal
            name: HARDCODE.idTipoPeriodicidadeMensal,
            descricao: 'Mensal',
            label: 'Mensal',
            descricaoTempo: '',
            fatorConversaoMensal: 1, // HARDCODEBACKEND.fatorConversaoMensalMensal
            mesesFluxoCaixa: [
                [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8}, {id: 9}, {id: 10}, {id: 11}, {id: 12}],
                [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8}, {id: 9}, {id: 10}, {id: 11}, {id: 12}],
                [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8}, {id: 9}, {id: 10}, {id: 11}, {id: 12}],
                [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8}, {id: 9}, {id: 10}, {id: 11}, {id: 12}],
                [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8}, {id: 9}, {id: 10}, {id: 11}, {id: 12}],
                [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8}, {id: 9}, {id: 10}, {id: 11}, {id: 12}],
                [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8}, {id: 9}, {id: 10}, {id: 11}, {id: 12}],
                [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8}, {id: 9}, {id: 10}, {id: 11}, {id: 12}],
                [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8}, {id: 9}, {id: 10}, {id: 11}, {id: 12}],
                [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8}, {id: 9}, {id: 10}, {id: 11}, {id: 12}],
                [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8}, {id: 9}, {id: 10}, {id: 11}, {id: 12}],
                [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8}, {id: 9}, {id: 10}, {id: 11}, {id: 12}],
            ],
            anosFluxoCaixa: null,
            ordem: 10,
        },
        {
            id: HARDCODE.idTipoPeriodicidadeAnual, // HARDCODEBACKEND.idTipoPeriodicidadeAnual
            name: HARDCODE.idTipoPeriodicidadeAnual,
            descricao: 'Anual',
            label: 'Anual',
            descricaoTempo: 'anos',
            fatorConversaoMensal: 12, // HARDCODEBACKEND.fatorConversaoMensalAnual
            mesesFluxoCaixa: [
                [{id: 1}],
                [{id: 2}],
                [{id: 3}],
                [{id: 4}],
                [{id: 5}],
                [{id: 6}],
                [{id: 7}],
                [{id: 8}],
                [{id: 9}],
                [{id: 10}],
                [{id: 11}],
                [{id: 12}],
            ],
            anosFluxoCaixa: null,
            ordem: 20,
        },
        {
            id: HARDCODE.idTipoPeriodicidadeSemestral, // HARDCODEBACKEND.idTipoPeriodicidadeSemestral
            name: HARDCODE.idTipoPeriodicidadeSemestral,
            descricao: 'Semestral',
            label: 'Semestral',
            descricaoTempo: 'semestres',
            fatorConversaoMensal: 6, // HARDCODEBACKEND.fatorConversaoMensalSemestral
            mesesFluxoCaixa: [
                [{id: 1},  {id: 7}],
                [{id: 2},  {id: 8}],
                [{id: 3},  {id: 9}],
                [{id: 4},  {id: 10}],
                [{id: 5},  {id: 11}],
                [{id: 6},  {id: 12}],
                [{id: 7},  {id: 1}],
                [{id: 8},  {id: 2}],
                [{id: 9},  {id: 3}],
                [{id: 10}, {id: 4}],
                [{id: 11}, {id: 5}],
                [{id: 12}, {id: 6}],
            ],
            anosFluxoCaixa: null,
            ordem: 30,
        },
        {
            id: 'Q', // HARDCODEBACKEND.idTipoPeriodicidadeQuadrimestral
            name: 'Q',
            descricao: 'Quadrimestral',
            label: 'Quadrimestral',
            descricaoTempo: 'quadrimestres',
            fatorConversaoMensal: 4, // HARDCODEBACKEND.fatorConversaoMensalQuadrimestral
            mesesFluxoCaixa: [
                [{id: 1},  {id: 5},  {id: 9}],
                [{id: 2},  {id: 6},  {id: 10}],
                [{id: 3},  {id: 7},  {id: 11}],
                [{id: 4},  {id: 8},  {id: 12}],
                [{id: 5},  {id: 9},  {id: 1}],
                [{id: 6},  {id: 10}, {id: 2}],
                [{id: 7},  {id: 11}, {id: 3}],
                [{id: 8},  {id: 12}, {id: 4}],
                [{id: 9},  {id: 1},  {id: 5}],
                [{id: 10}, {id: 2},  {id: 6}],
                [{id: 11}, {id: 3},  {id: 7}],
                [{id: 12}, {id: 4},  {id: 8}],
            ],
            anosFluxoCaixa: null,
            ordem: 40,
        },
        {
            id: HARDCODE.idTipoPeriodicidadeTrimestral, // HARDCODEBACKEND.idTipoPeriodicidadeTrimestral
            name: HARDCODE.idTipoPeriodicidadeTrimestral,
            descricao: 'Trimestral',
            label: 'Trimestral',
            descricaoTempo: 'trimestres',
            fatorConversaoMensal: 3, // HARDCODEBACKEND.fatorConversaoMensalTrimestral
            mesesFluxoCaixa: [
                [{id: 1},  {id: 4},  {id: 7},  {id: 10}],
                [{id: 2},  {id: 5},  {id: 8},  {id: 11}],
                [{id: 3},  {id: 6},  {id: 9},  {id: 12}],
                [{id: 4},  {id: 7},  {id: 10}, {id: 1}],
                [{id: 5},  {id: 8},  {id: 11}, {id: 2}],
                [{id: 6},  {id: 9},  {id: 12}, {id: 3}],
                [{id: 7},  {id: 10}, {id: 1},  {id: 4}],
                [{id: 8},  {id: 11}, {id: 2},  {id: 5}],
                [{id: 9},  {id: 12}, {id: 3},  {id: 6}],
                [{id: 10}, {id: 1},  {id: 4},  {id: 7}],
                [{id: 11}, {id: 2},  {id: 5},  {id: 8}],
                [{id: 12}, {id: 3},  {id: 6},  {id: 9}],
            ],
            anosFluxoCaixa: null,
            ordem: 50,
        },
        {
            id: 'B', // HARDCODEBACKEND.idTipoPeriodicidadeBimestral
            name: 'B',
            descricao: 'Bimestral',
            label: 'Bimestral',
            descricaoTempo: 'bimestres',
            fatorConversaoMensal: 2, // HARDCODEBACKEND.fatorConversaoMensalBimestral
            mesesFluxoCaixa: [
                [{id: 1},  {id: 3},  {id: 5},  {id: 7},  {id: 9},  {id: 11}],
                [{id: 2},  {id: 4},  {id: 6},  {id: 8},  {id: 10}, {id: 12}],
                [{id: 3},  {id: 5},  {id: 7},  {id: 9},  {id: 11}, {id: 1}],
                [{id: 4},  {id: 6},  {id: 8},  {id: 10}, {id: 12}, {id: 2}],
                [{id: 5},  {id: 7},  {id: 9},  {id: 11}, {id: 1},  {id: 3}],
                [{id: 6},  {id: 8},  {id: 10}, {id: 12}, {id: 2},  {id: 4}],
                [{id: 7},  {id: 9},  {id: 11}, {id: 1},  {id: 3},  {id: 5}],
                [{id: 8},  {id: 10}, {id: 12}, {id: 2},  {id: 4},  {id: 6}],
                [{id: 9},  {id: 11}, {id: 1},  {id: 3},  {id: 5},  {id: 7}],
                [{id: 10}, {id: 12}, {id: 2},  {id: 4},  {id: 6},  {id: 8}],
                [{id: 11}, {id: 1},  {id: 3},  {id: 5},  {id: 7},  {id: 9}],
                [{id: 12}, {id: 2},  {id: 4},  {id: 6},  {id: 8},  {id: 10}],
            ],
            anosFluxoCaixa: null,
            ordem: 60,
        },
    ]

    if (incluirOpcaoSinglePremium) {

        tipoPeriodicidadeListAux.push(
            {
                id: HARDCODE.idTipoPeriodicidadeUnica, // HARDCODEBACKEND.idTipoPeriodicidadeUnica
                name: HARDCODE.idTipoPeriodicidadeUnica,
                descricao: 'Única',
                label: 'Única',
                descricaoTempo: 'Única',
                fatorConversaoMensal: 12, // HARDCODEBACKEND.fatorConversaoMensalAnual
                mesesFluxoCaixa: [
                    [{id: 1}],
                    [{id: 2}],
                    [{id: 3}],
                    [{id: 4}],
                    [{id: 5}],
                    [{id: 6}],
                    [{id: 7}],
                    [{id: 8}],
                    [{id: 9}],
                    [{id: 10}],
                    [{id: 11}],
                    [{id: 12}],
                ],
                anosFluxoCaixa: null,
                ordem: 70,
            },
        )
    }

    if (incluiMultiplosAnuais) {

        tipoPeriodicidadeListAux.push(
            {
                id: '2',
                name: '2',
                descricao: 'Bianual',
                label: 'Bianual',
                descricaoTempo: 'biênios',
                fatorConversaoMensal: 12,
                mesesFluxoCaixa: [
                    [{id: 1}],
                    [{id: 2}],
                    [{id: 3}],
                    [{id: 4}],
                    [{id: 5}],
                    [{id: 6}],
                    [{id: 7}],
                    [{id: 8}],
                    [{id: 9}],
                    [{id: 10}],
                    [{id: 11}],
                    [{id: 12}],
                ],
                anosFluxoCaixa: 2,
                ordem: 80,
            },
        )

        tipoPeriodicidadeListAux.push(
            {
                id: '3',
                name: '3',
                descricao: 'Trianual',
                label: 'Trianual',
                descricaoTempo: 'triênios',
                fatorConversaoMensal: 12,
                mesesFluxoCaixa: [
                    [{id: 1}],
                    [{id: 2}],
                    [{id: 3}],
                    [{id: 4}],
                    [{id: 5}],
                    [{id: 6}],
                    [{id: 7}],
                    [{id: 8}],
                    [{id: 9}],
                    [{id: 10}],
                    [{id: 11}],
                    [{id: 12}],
                ],
                anosFluxoCaixa: 3,
                ordem: 90,
            },
        )

        tipoPeriodicidadeListAux.push(
            {
                id: '4',
                name: '4',
                descricao: 'Quadrienual',
                label: 'Quadrienual',
                descricaoTempo: 'quadriênios',
                fatorConversaoMensal: 12,
                mesesFluxoCaixa: [
                    [{id: 1}],
                    [{id: 2}],
                    [{id: 3}],
                    [{id: 4}],
                    [{id: 5}],
                    [{id: 6}],
                    [{id: 7}],
                    [{id: 8}],
                    [{id: 9}],
                    [{id: 10}],
                    [{id: 11}],
                    [{id: 12}],
                ],
                anosFluxoCaixa: 4,
                ordem: 100,
            },

            {
                id: '5',
                name: '5',
                descricao: 'Quinquenal',
                label: 'Quinquenal',
                descricaoTempo: 'quinquênios',
                fatorConversaoMensal: 12,
                mesesFluxoCaixa: [
                    [{id: 1}],
                    [{id: 2}],
                    [{id: 3}],
                    [{id: 4}],
                    [{id: 5}],
                    [{id: 6}],
                    [{id: 7}],
                    [{id: 8}],
                    [{id: 9}],
                    [{id: 10}],
                    [{id: 11}],
                    [{id: 12}],
                ],
                anosFluxoCaixa: 5,
                ordem: 110,
            },
        )
    }

    if (listaCompleta) {

        tipoPeriodicidadeListAux.push(
            {
                id: 'N', // HARDCODEBACKEND.idTipoPeriodicidadeNaoInformada
                name: 'N',
                descricao: 'Não Informada',
                label: 'Não Informada',
                descricaoTempo: null,
                fatorConversaoMensal: null,
                mesesFluxoCaixa: null,
                anosFluxoCaixa: null,
                ordem: 120,
            },
        )
    }

    return tipoPeriodicidadeListAux
}

export default tipoPeriodicidadeList
